import SignIn from "../modules/auth/sign-in";
import SignUp from "../modules/auth/sign-up";
import ForgotPassword from "../modules/auth/forgot-password";
import ResetPassword from "../modules/auth/reset-password";
import DemoLogin from "../modules/auth/demo-login";
import AuthLayout from "../components/AuthLayout";

export const Auth = [
  {
    element: <AuthLayout />,
    children: [
      {
        path: "/sign-in",
        element: <SignIn />,
      },
      {
        path: "/sign-up",
        element: <SignUp />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/reset-password",
        element: <ResetPassword />,
      },
      {
        path: "/demo",
        element: <DemoLogin />,
      },
    ],
  },
];
